const BaseFilter = require("app/components/filters/CategoryFilter");
const productsApi = require("app/pipelines/products-api");

class CategoryFilter extends BaseFilter {

	componentDidMount() {
		productsApi.request.pipe(payload => {
			if (this.state.activeItem) {
				payload.subgroup = this.state.activeItem;
			}

			// Subgroups counter
			payload.$subgroups = this.state.items.map(item => item.guid);

			return payload;
		});

		productsApi.response.pipe(payload => {
			if (payload.subgroups instanceof Array) {
				this.setState({items: payload.subgroups});
			}

			return payload;
		});
	}

	onActivate(guid) {
		super.onActivate(guid);
		productsApi.request.dispatch();
	}

}

module.exports = CategoryFilter;